import { Pagination, listClasses } from "@mui/material";
import useStateRef from 'react-usestateref';

import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import { Link, json } from "react-router-dom";
import Card from "../../../components/Card";  
import swal from 'sweetalert';
import config from "../../../config/config";
import apiPath from "../../../config/apipath";
import apiService from "../../../provider/apiService";
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select';
import {useLocation } from 'react-router-dom';

const PurchaseTable = () => {

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const [purchasedetail, setPurchasedeatail] = useState([]);
  const [nopage, setnopage, nopageRef] = useStateRef();
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();
  const [page, setpage, pageRef] = useStateRef('1');

  const handleClose1 = () => setShow1(false);

  const [Search, setSearch, SearchRef] = useStateRef('');

  const [NewElg, setNewElg] = useState(false);
  const [EditElg, setEditElg,EditElgRef] = useStateRef(false);
  const [DeleteElg, setDeleteElg] = useState(false);
  const [ViewElg, setViewElg] = useState(false);
  const [btndisabled, setDisabled] = useState('disabled');
  

  const [dealersmithlist, setDealersmithlist] = useState([]);
  const [deparmentlist, setDeparmentlist] = useState([]);
  const [prodlist, setProdlist, prodlistRef] = useStateRef([]);
  const [ttypelist, setTtypelist, ttypelistRef] = useStateRef([]);

  const [item, setItem] = useState([]);

  const [accid, setAccid, accidRef] = useStateRef('');
  const [group, setGroup, groupRef] = useStateRef('');
  const [dept, setDept, deptRef] = useStateRef('');
  const [fproditem, setFproditem, fproditemRef] = useStateRef('');
  const [proditem, setProditem, proditemRef] = useStateRef(['']);

  const [pname, setPname, pnameRef] = useStateRef('');
  const [product, setProduct, productRef] = useStateRef('');
  const [purity, setPurity, purityRef] = useStateRef('');

  //check boxes 1
  const [optMGWt, setOptMGWt, optMGWtRef] = useStateRef('');
  const [optMPcs, setOptMPcs, optMPcsRef] = useStateRef('');

  const [mcGram, setMcGram, mcGramRef] = useStateRef('');
  const [mcPcs, setMcPcs, mcPcsRef] = useStateRef('');

  //check boxes 2
  const [optWGWt, setOptWGWt, optWGWtRef] = useStateRef('');
  const [optWPcs, setOptWPcs, optWPcsRef] = useStateRef('');

  const [wasteGram, setWasteGram, wasteGramRef] = useStateRef('');
  const [wastePcs, setWastePcs, wastePcsRef] = useStateRef('');

  const [touch, setTouch, touchRef] = useStateRef('');
  const [dueDays, setDueDays, dueDaysRef] = useStateRef('');

  const [sstatement, setSstatement, sstatementRef] = useStateRef();
  const [EditId,setEditId]=useState(0);

  const [localtime,setlocaltime] =useState(new Date());

  const [currentDate,setcurrentDate]=useState(new Date().toJSON().slice(0, 10));

  const location = useLocation();

  useEffect(() => {
    if (location.state!=undefined || location.state!=null){

    setNewElg(location.state.NewElg);
      setEditElg(location.state.EditElg);
      setDeleteElg(location.state.DeleteElg);
      setViewElg(location.state.ViewElg);

      sessionStorage.setItem("PurDetail_NewElg", location.state.NewElg);
      sessionStorage.setItem("PurDetail_EditElg", location.state.EditElg);
      sessionStorage.setItem("PurDetail_DeleteElg", location.state.DeleteElg);
      sessionStorage.setItem("PurDetail_ViewElg", location.state.ViewElg);
    }
    else
    {
      setNewElg(sessionStorage.getItem("PurDetail_NewElg")==='true' ? true: false);
      setEditElg(sessionStorage.getItem("PurDetail_EditElg")==='true' ? true: false);
      setDeleteElg(sessionStorage.getItem("PurDetail_DeleteElg")==='true' ? true: false);
      setViewElg(sessionStorage.getItem("PurDetail_ViewElg")==='true' ? true: false);
    }
      if (EditElgRef.current==true){
        setDisabled('');
      }
      else
      {
        setDisabled('disabled');
      }


    setpage(1);
    getPurchasedetail()
    getdealersmithlist()
    getDepartmentlist()
    getproductlist()
    getTagTypelist()
    getItem()

    setcurrentDate(new Date().toJSON().slice(0, 10));
    
  }, []);

  const purchasedetailPg = (event, value) => {
    setpage(value);
    getPurchasedetail();
  };

  async function setCheck(value,id)
  {

    
    let i=0;

   
   
    for(i=0;i<proditem.length;i++)
    {
      if(id==proditem[i].SubCode)
      {
        proditem[i].checked=value;
        
      } 
     
  }
  
  setlocaltime(new Date());



  }
  async function Edit(id)
  {
    setEditId(id);  
    let postData = {
      EditId:id
    }
    
    let results = await apiService.postCall('master/purchasedetaildisplay', postData);
    if (results != "-1") {
    let head=results.data.Head;
    let detail=results.data.Detail[0];

   

    setGroup(head[0][0].GCode);
    
    setcurrentDate(head[0][0].SDate.slice(0,10));
    setDept(head[0][0].DeptCode);
    
    setProduct(head[0][0].ProdCode);
    let res = prodlist.filter((item) => item.value ==head[0][0].ProdCode);
    setFproditem(res[0].value);
    
    setWasteGram(head[0][0].WasteGram);
    
    setMcGram(head[0][0].McGram)
    setMcPcs(head[0][0].McPcs)
    
    setWasteGram(head[0][0].WasteGram)
    setWastePcs(head[0][0].Waste)
    setTouch(head[0][0].Touch)
    setDueDays(head[0][0].DueDays)
    setPname(head[0][0].AccCode);
    setPurity(head[0][0].TagType);

    setOptMGWt(head[0][0].OptMGWt);
    setOptMPcs(head[0][0].OptMPcs);
    setOptWGWt(head[0][0].OptWGWt);
    setOptWPcs(head[0][0].OptWPc)
  

    
      //setItem(detail[0]);



           
      setSho('Edit');
      setShow('Update');
  
    
  
      setShow1(true);

      let i=0;
      let j=0;

    

      for(j=0;j<detail.length;j++)
      {
      for(i=0;i<proditem.length;i++)
      {
        if(detail[j].SubCode==proditem[i].SubCode)
        {
          proditem[i].checked=true;
        } 
        
      }
    }









    }


  }

  async function Add()
  {
    setEditId(0);

    handleShow1(1, " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", "Insert", true)
  }

  async function getPurchasedetail() {
    try {
      let page_no = String(pageRef.current)
      let Rows_Page = String(config.pageCount)
      let postData = {
        PageNumber: page_no,
        RowspPage: Rows_Page,
        Search:SearchRef.current
      }
      let results = await apiService.getPurchasedetail(apiPath.master.get.getPurchasedetail, postData);
      if (results != "-1") {
       

        setPurchasedeatail(results.data[0]);
        settotalCount(results.totalCount);
        setcurrentpg(postData.PageNumber);
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function getdealersmithlist() {
    try {
      let results = await apiService.getdealersmithlist(apiPath.master.get.getdealersmithlist);
      if (results != "-1") {
        
        

        setDealersmithlist(results.data[0]);
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function getDepartmentlist() {
    try {
      let postData = {
        departmentmasterId: "0"
      }
      let results = await apiService.getDepartment(apiPath.master.get.getdepartment, postData);
      if (results != "-1") {
        console.log(results, "department");
        setDeparmentlist(results.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getproductlist() {
    try {
      let results = await apiService.getproductlist(apiPath.master.get.getproductlist);
      if (results != "-1") {

       // alert(JSON.stringify(results.data[0]));

        setProdlist(results.data[0]);
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function getTagTypelist() {
    try {
     
      let tag=[
        {Purity:'91.6'},
         {Purity:'ORDINARY'}
       ]

      setTtypelist(tag);

    } catch (error) {
      console.log(error);
    }
  }

  async function getItem() {
    try {
      let results = await apiService.getItem(apiPath.master.get.getItem);
      if (results != "-1") {
        setProditem(results.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function insertUpdatePurchase() {
    try {

     

      let lstitems= document.getElementsByClassName("lstItems");

      let i=0;
      let idlist=[];
      let cnt=0;
      for(i=0;i<lstitems.length;i++)
      {
        let item=lstitems[i];
        
        if (item.checked==true)
        {
          let r={"SubCode":item.id};
          idlist[cnt]=r;
          cnt=cnt+1;
        }
      }

   
      

        let postData = {
        LinkNo:EditId,
        Group:groupRef.current,
        PartyName:pnameRef.current,
        SDate:document.getElementById("txtSDate").value,
        Dept:document.getElementById("txtDept").value,
        Product:productRef.current,
        Purity:purityRef.current,
        MCPcs:val(document.getElementById("txtMCPPcs").value),
        MCPgrm:val(document.getElementById("txtMCPgrm").value),
        WasteP:val(document.getElementById("txtWasteP").value),
        WastePgrm:val(document.getElementById("txtWastePgrm").value),
        Touch:val(document.getElementById("txtTouch").value),
        DueDays:val(document.getElementById("txtDueDays").value),
        optMGWt:document.getElementById("optMGWt").checked==true ? true : false,
        optMPcs:document.getElementById("optMPcs").checked==true ? true : false,
        optWGWt:document.getElementById("optWGWt").checked==true ? true : false,
        optWPcs:document.getElementById("optWPcs").checked==true ? true : false,
        DetTable1:idlist


       
      }
      
  if (EditId==0)
      {
      
      const results = await apiService.postCall("master/insertpurchasedetail",postData);

   if (results != "-1") {
      
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"
 
    }).then(function () {
      getPurchasedetail();
      handleClose1();
    });

  }

  }
 else
 {
 
 const results = await apiService.postCall("master/updatepurchasedetail",postData);

if (results != "-1") {
 
swal({

 title: "Success",
 text: "Successfully Update Your Details!",
 icon: "success",
 button: "Ok"

}).then(function () {
 getPurchasedetail();
 handleClose1();
});

}

}



    } catch (error) {
      console.log(error);
    }
  }

  function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}


  const handleShow1 = (type, group, pname, dept, product, purity,
    optMGWt, optMPcs, mcGram, mcPcs, optWGWt, optWPc, wasteGram, wastePcs, touch, dueDays, statement, show) => {

    setGroup(group);
    setPname(pname);
    setDept(dept);
    setProduct(product);
    setPurity(purity);

    setAccid("")

    setOptMGWt(optMGWt)
    setOptMPcs(optMPcs)
    setMcGram(mcGram)
    setMcPcs(mcPcs)
    setOptWGWt(optWGWt)
    setOptWPcs(optWPc)
    setWasteGram(wasteGram)
    setWastePcs(wastePcs)
    setTouch(touch)
    setDueDays(dueDays)
    setSstatement(statement)



    if (type == 1) {
      setSho('Add New');
      setShow('Save');
    } else {
      setSho('Edit');
      setShow('Update');
    }
    setShow1(show);
  }


  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">To Add, Modify Purchase Master details.</h4>
             
                <Toaster
                  position="bottom-right"
                  reverseOrder={false}
                />
                 </div>

              <div>
                <div style={{ display: 'flex', marginLeft: '91px', alignItems: 'center' }}>
                  <div style={{ paddingRight: '10px' }}>
                    <Form.Control type="search" value={Search}  onChange={(e)=>{setSearch(e.target.value)}} className="form-control mr-sm-2" placeholder="Search" aria-label="Search" />
                  </div>
                  <div >
                    <Button className="text-center btn-primary btn-sm btn-icon mt-lg-0 mt-md-0 mt-3 " onClick={(e)=>{
                       setcurrentpg(1)
                       getPurchasedetail()}}>
                 <i className="btn-inner">
                        <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                          <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </i>
                    </Button>
                  </div>
                </div>
              </div>


              <div className="col d-flex justify-content-end">
               {NewElg &&  <Button className="text-center btn-primary btn-icon mt-lg-0 mt-md-0 mt-3 "
                  onClick={() => { Add() }}>
                  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
                  <span>Add</span>
                </Button>}
                <Modal show={show1} onHide={handleClose1} >
                  <Modal.Header closeButton>
                    <Modal.Title>{sho} Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group style={{ height: '60vh', overflowY: 'scroll', overflowX: 'hidden' }} className="mb-3 container">
                      <div className='mb-3'>
                        <Form.Label>Group</Form.Label>
                        <select className="form-select" id="txtGroup" value={group} disabled={true}  >
                          <option value="" ></option>
                          <option value={0}>NONE</option>
                          <option value={1}>SMITH</option>
                          <option value={2}>DEALER</option>
                          <option value={3}>SMITH AND DEALER</option>
                        </select>
                      </div>

                      <div className='mb-3'>
                        <Form.Label>Party Name </Form.Label>

                        <Select className="" id="txtPartyName" 
                             options={dealersmithlist}
                             value={dealersmithlist.filter(function(option) {
                              return option.value === pname;
                            })}
                            onChange=
                            {
                              (e) => {

                                 setPname(e.value);
                                 let res = dealersmithlist.filter((item) => item.value == e.value);
                                 setAccid(res[0].Id)
                                 setGroup(res[0].GCode);
                                 setDept(res[0].DeptCode);
                              }
                              }
                             >

                             </Select>
                       

                      </div>

                      <div className='mb-3'>
                        <Form.Label>Date</Form.Label>
                        <Form.Control class="text-center" id="txtSDate" type="text" value={currentDate} disabled={true} />
                      </div>

                      <div className='mb-3'>
                        <Form.Label> Dept.</Form.Label>
                        <select className="form-select" id="txtDept" value={dept} disabled={accidRef.current != 0 ? true : false}>
                          <option value=" " >--Select--</option>
                          {deparmentlist.map((deparmentlist) => (
                            <option value={deparmentlist.Code}>{deparmentlist.DeptName}</option>
                          ))}
                        </select>
                      </div>

                      <div className='mb-3'>
                        <Form.Label> Product </Form.Label>

                        <Select className="" id="txtProduct" 
                             options={prodlist}
                             value={prodlist.filter(function(option) {
                              return option.value === product;
                            })}
                            onChange=
                            {
                              (e) => {

                                setProduct(e.value)
                                let res = prodlist.filter((item) => item.value == e.value);
                               
                                setFproditem(res[0].value);
                              }
                              }
                             >

                             </Select>

                       
                      </div>

                      <div className='mb-3'>
                        <Form.Label>Purity </Form.Label>
                        <select className="form-select" id="txtPurity" value={purity} onChange={(e) => setPurity(e.target.value)} >
                          <option value="" >--Select Purity--</option>
                          {ttypelist.map((ttypelist) => (
                            <option value={ttypelist.Purity}>{ttypelist.Purity}</option>
                          ))}
                        </select>
                      </div>

                      <div className='d-flex mb-3 justify-content-evenly container'>
                        <div>
                          <Form.Check.Input className="me-2" id="optMGWt" type="radio" checked={optMGWt} onChange={(e) => setOptMGWt(e.target.checked)} name="flexRadioDefault1" />
                          <Form.Check.Label htmlFor="flexRadioDefault1" >GrossWt.</Form.Check.Label>
                        </div>
                        <div>
                          <Form.Check.Input className="me-2"  id="optMPcs" type="radio" checked={optMPcs} onChange={(e) => setOptMPcs(e.target.checked)} name="flexRadioDefault1" />
                          <Form.Check.Label htmlFor="flexRadioDefault1" > Pieces</Form.Check.Label>
                        </div>
                      </div>

                      <div className='mb-3'>
                        <div className='row'>
                          <div className='col-md-6'>
                            <Form.Label>M.C./Pcs </Form.Label>
                            <Form.Control type="text" id="txtMCPPcs" value={mcGram} onChange={(e) => setMcGram(e.target.value)} />
                          </div>
                          <div className='col-md-6'>
                            <Form.Label>M.C./Gram </Form.Label>
                            <Form.Control type="text" value={mcPcs} id="txtMCPgrm" onChange={(e) => setMcPcs(e.target.value)} />
                          </div>
                        </div>
                      </div>

                      <div className='d-flex mb-3 justify-content-evenly container'>
                        <div>
                          <Form.Check.Input className="me-2" type="radio"  id="optWGWt" checked={optWGWt} onChange={(e) => {
                            setOptWGWt(e.target.checked)
                            setOptWPcs(false)
                          }
                          } name="flexRadioDefault2" />
                          <Form.Check.Label htmlFor="flexRadioDefault2" >GrossWt.</Form.Check.Label>
                        </div>
                        <div>
                          <Form.Check.Input className="me-2"  id="optWPcs" type="radio" checked={optWPcs} onChange={(e) => setOptWPcs(e.target.checked)} name="flexRadioDefault2" />
                          <Form.Check.Label htmlFor="flexRadioDefault2"> Pieces</Form.Check.Label>
                        </div>
                      </div>

                      <div className='mb-3'>
                        <div className='row'>
                          <div className='col-md-6'>
                            <Form.Label>Waste% </Form.Label>
                            <Form.Control type="text" id="txtWasteP" value={wastePcs} onChange={(e) => setWastePcs(e.target.value)} />
                          </div>
                          <div className='col-md-6'>
                            <Form.Label>Waste/Gram </Form.Label>
                            <Form.Control type="text" id="txtWastePgrm" value={wasteGram} onChange={(e) => setWasteGram(e.target.value)} />
                          </div>
                        </div>
                      </div>

                      <div className='mb-3'>
                        <div className='row'>
                          <div className='col-md-6'>
                            <Form.Label>Touch </Form.Label>
                            <Form.Control type="text" id="txtTouch" value={touch} onChange={(e) => setTouch(e.target.value)} />
                          </div>
                          <div className='col-md-6'>
                            <Form.Label>Due Days </Form.Label>
                            <Form.Control type="text" id="txtDueDays" value={dueDays} onChange={(e) => setDueDays(e.target.value)} />
                          </div>
                        </div>
                      </div>

                      <div className='mb-3' >
                        <div className="border border-1  p-3 rounded-3">
                          <div className='row'>
                            <div className='col mb-1'>
                              {
                                proditem.filter((item) => item.ProdCode == fproditem).length > 0 ? (
                                  proditem.filter((item) => item.ProdCode == fproditem).map((item) => (
                                    <div key={item.SubCode}>
                                      <Form.Check className="me-2">
                                        
                                        <Form.Check.Input type="checkbox" checked={item.checked} onChange={(e) => setCheck(e.target.checked,item.SubCode)} className="lstItems" id={item.SubCode} />
                                        
                                        <Form.Check.Label>{item.ItemName.toUpperCase()}</Form.Check.Label>
                                      </Form.Check>
                                    </div>
                                  ))
                                ) : (
                                  <p className="my-n2">No items available.</p>
                                )
                              }
                            </div>


                          </div>
                        </div>
                      </div>

                    </Form.Group>

                    <div style={{ "direction": 'rtl' }}>
                      <Button variant="primary" disabled={btndisabled} onClick={insertUpdatePurchase}>{show} </Button>		{' '}
                      <Button variant="danger" onClick={handleClose1}>  Cancel </Button>
                    </div>

                  </Modal.Body>
                </Modal>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive border-bottom my-3">
                <Table
                  responsive
                  striped
                  id="datatable"
                  className=""
                  data-toggle="data-table"
                >
                  <thead>
                    <tr>
                      <th>Party Name</th>
                      <th>Date</th>
                      <th>Mc Gram</th>
                      <th>Waste</th>
                      <th>Touch</th>
                      <th>Group Name</th>

                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchasedetail.map((item) => (
                      <tr>
                        <td style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{item.PartyName}</td>
                        <td>{item.date}</td>
                        <td>{item.McGram}</td>
                        <td>{item.Waste}</td>
                        <td>{item.Touch}</td>
                        <td>{item.GroupName}</td>
                        {(EditElg || ViewElg) &&  <td>
                          <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit User" to="#"
                            onClick={() => { Edit(item.id) }} >
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
                        </td>}
                        {DeleteElg && 
                        <td>
                          <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete User" to="#" onClick={() => { }}>
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>

                        </td>}

                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 0 3px 0px', width: '100%', justifyContent: 'space-between' }}>
                  <div>
                    Showing {(currentpgRef.current - 1) * 10 + 1} to {currentpgRef.current * 10} of {totalCountRef.current} entries
                  </div>
                  <div>   <Pagination count={Math.ceil(totalCountRef.current / config.pageCount)} page={nopageRef.current} color="primary" onChange={purchasedetailPg} />
                  </div>

                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PurchaseTable;
